import useAuth from 'hooks/use-auth'

export function withAuthContext(WrappedComponent) {
  return function WithAuthenticationContainer(props) {
    const authState = useAuth()
    return <WrappedComponent authState={authState} {...props} />
  }
}
